import { SVGProps, Ref, forwardRef } from 'react'
const SvgColorLinkedIn = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 25 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path fill="#fff" stroke="#979797" d="M2.697 2.19h19.709v18.614H2.697z" />
    <path
      fill="#0A66C2"
      fillRule="evenodd"
      d="M2.702.002h19.651V0a1.686 1.686 0 0 1 1.709 1.662v19.735a1.688 1.688 0 0 1-1.709 1.664H2.702c-.93.01-1.691-.735-1.702-1.664V1.664A1.683 1.683 0 0 1 2.702.002Zm1.446 5.156a1.983 1.983 0 1 0 3.966 0 1.983 1.983 0 0 0-3.966 0ZM17.233 19.65h3.417l.001-6.037c0-2.964-.638-5.242-4.102-5.242a3.595 3.595 0 0 0-3.236 1.778h-.046V8.645h-3.28v11.004h3.416v-5.444c0-1.435.273-2.825 2.052-2.825 1.755 0 1.778 1.642 1.778 2.918v5.352Zm-9.394 0H4.418V8.645h3.42V19.65Z"
      clipRule="evenodd"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgColorLinkedIn)
export default ForwardRef
